var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScientist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    transform: "translate(0, 0) scale(1, 1) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,17c-2.67,0-8,1.34-8,4v3H16V21C16,18.34,10.67,17,8,17Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 3.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 1.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,7V8h1l.00285,10.03118C17,19.71222,18,21,19.5,21S22,19.79326,22,18V8h1V7Zm5,8-.56537.424a1.76514,1.76514,0,0,1-1.04925.326H19V15H18V13h1V12H18V10h1V9H18V8h3Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScientist);
export default __webpack_public_path__ + "static/media/scientist.626f251b33405b405fa1ae538ea5c3da.svg";
export { ForwardRef as ReactComponent };